import { render, staticRenderFns } from "./blind_transaction_settings.vue?vue&type=template&id=b1a0b4ac&"
import script from "./blind_transaction_settings.vue?vue&type=script&lang=js&"
export * from "./blind_transaction_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports